import {ROOT_DRAWER_POINTER} from "../components/RootComponents/RootDrawer"

export const VorsorgeAssistentActions = ({
    updateData,
    getDataFromPointer,
    getDataFromBackend,
}) => ({
    OPEN_VERSORGUNG_DRAWER: () => {
        updateData("VERSORGUNG", ROOT_DRAWER_POINTER)
    },
    INIT_VORSORGE_ASSISTENT: () => {
        const addKundeNpLink = getDataFromPointer("/links/addKundeNp")
        if (!addKundeNpLink?.href) {
            console.warn("[INIT_VORSORGE_ASSISTENT] /links/addKundeNp fehlt — Staging Area wird nicht initialisiert")
            return Promise.resolve()
        }
        const mergeLinks = (_data, newLinks) => ({
            ...getDataFromPointer("/links"),
            ...newLinks,
        })
        return getDataFromBackend(addKundeNpLink)
            .then((payload) => {
                const createStagingAreaLink = payload?._data?._links?.createStagingArea
                if (!createStagingAreaLink?.href) {
                    console.warn("[INIT_VORSORGE_ASSISTENT] createStagingArea-Link fehlt in addKundeNp-Response")
                    return
                }
                return getDataFromBackend(createStagingAreaLink, "/links", mergeLinks)
            })
    },
})
